<template>
  <div class="operationManagement">
    <communication-table
      :table="communicateTable"
      tableName="前期沟通"
      @addTableItem="addTableItem"
      @saveTableItem="saveTableItem"
      @handleTextClick="handleTextClick"
      @deleteTableItem="deleteTableItem"
    />
    <communication-table
      :table="issueTable"
      tableName="面试问题"
      @addTableItem="addTableItem"
      @saveTableItem="saveTableItem"
      @handleTextClick="handleTextClick"
      @deleteTableItem="deleteTableItem"
    />
  </div>
</template>

<script>
import {
  addVerbalTrick,
  updateVerbalTrick,
  getVerbalTrick,
  deleteVerbalTrick
} from '@/api/projectCenter'
import communicationTable from './cpns/communicationTable.vue'

export default {
  name: 'OperationManagement',

  components: {
    communicationTable
  },

  data() {
    return {
      communicateTable: [], // 前期沟通列表表格数据
      issueTable: [] // 面试问题表格数据
    }
  },

  computed: {
    id() {
      return Number(this.$route.query.id)
    },
    searchInfo() {
      return JSON.parse(this.$route.query.searchInfo)
    }
  },

  created() {
    this.$store.commit('changeQueryInfo', this.searchInfo)
    this.search()
  },

  methods: {
    // 查询
    async search() {
      this.communicateTable = []
      this.issueTable = []
      const { data: res } = await getVerbalTrick({ id: this.id })
      if (res.resultCode === 200) {
        res.data.forEach((item) => {
          this.$set(item, 'isShowOutlineInput', false)
          this.$set(item, 'isShowContentInput', false)
          if (item.state === '0') {
            this.communicateTable.unshift(item)
          } else {
            this.issueTable.unshift(item)
          }
        })
      }
    },
    // 添加
    addTableItem(name) {
      let addObj = {
        projectId: this.id,
        outline: '', // 大纲
        content: '', // 内容
        isShowOutlineInput: true, // 是否显示大纲输入框
        isShowContentInput: true // 是否显示内容输入框
      }
      if (name === '前期沟通') {
        addObj.state = 0
        this.communicateTable.push(addObj)
      } else {
        addObj.state = 1
        this.issueTable.push(addObj)
      }
    },
    // 保存
    async saveTableItem(val, name) {
      name === 'outline' ? (val.isShowOutlineInput = false) : (val.isShowContentInput = false)
      let res
      if (val.hasOwnProperty('id')) {
        // 修改
        res = await updateVerbalTrick(val)
      } else {
        // 新增
        res = await addVerbalTrick(val)
      }
      if (res.data.resultCode === 200) {
        this.$message.success(res.data.message)
        this.search()
      }
    },
    // 文字点击
    handleTextClick(val, name) {
      if (name === 'outline') {
        val.isShowOutlineInput = true
      } else {
        val.isShowContentInput = true
      }
    },
    // 删除
    async deleteTableItem(id) {
      this.$confirm('此操作不可撤回，请谨慎删除', '提示')
        .then(async () => {
          const { data: res } = await deleteVerbalTrick({ id })
          if (res.resultCode === 200) {
            this.$message.success('删除成功')

            this.search()
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.operationManagement {
  padding: 0 20px;
  background: #fff;
}
</style>
